import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const pdpVideoIconSelector = createSelector(testTargetOffersSelector, offers => offers.pdpVideoIcon || Empty.Object);

export { pdpVideoIconSelector };
